import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase from 'src/components/GridCellBase';

const DateCell: FC<GridCellProps> = (props: GridCellProps) => {
  const {
    dataItem: { transactionDate },
  } = props;

  return (
    <GridCellBase {...props} title={transactionDate}>
      <span>{transactionDate}</span>
    </GridCellBase>
  );
};

export default DateCell;
